module.exports = __webpack_public_path__ + "img/downloading.221fbae3.gif";